<template>
    <div v-if="settings.show">
        <b-modal v-model="airLeadInfoPopup" :content-class=" 'custom-modal ' + (settings.sectionClass ? settings.sectionClass : '')">
            <template v-slot:modal-header="{ close }">
                <span class="close-icon" @click="onClose"></span>
            </template>
            <div class="airLead__title">
                {{settings.title}}
            </div>
            <div v-if="settings.airlead && settings.type == 'new'" class="airLead">
                <div class="airLead__info">
                    <span>{{translate('airLeadInfoPopupDriver')}}:</span>
                    <div>{{settings.driver}}</div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('airLeadCompanyName')}}:</span>
                    <div>{{settings.company_name}}</div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('admin_phone')}} #</span>
                    <div>{{settings.phone}}</div>
                </div>
                <div class="airLead__info" v-if="settings.site_type">
                    <span>{{translate('airLeadSiteType')}}:</span>
                    <div>{{settings.site_type}}</div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('airLeadOpportunity')}}:</span>
                    <div>{{settings.opportunity}}</div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('airLeadInfoPopupNotes')}}:</span>
                    <div>{{settings.notes}}</div>
                </div>
                <div class="airLead__info" v-if="settings.location">
                    <span>{{translate('airLeadInfoPopupLocation')}}:</span>
                    <div>
                       <a @click="viewOnMapAction()" >{{translate('airLeadInfoPopupViewOnMap')}}</a>
                    </div>
                </div>
            </div>
            <div v-else-if="settings.airlead" class="airLead">
                <div class="airLead__info">
                    <span>{{translate('airLeadInfoPopupDriver')}}:</span>
                    <div>{{settings.driver}}</div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('airLeadCustomer')}}:</span>
                    <div>{{settings.customer_id}}</div>
                </div>
                <div class="airLead__info" v-if="settings.services.length > 0">
                    <span>{{translate('airLeadInfoPopupServices')}}:</span>
                    <div><span v-for="item in settings.services">{{getServiceName(item.name)}}{{' '}}({{item.comment}})<br></span></div>
                </div>
                <div class="airLead__info">
                    <span>{{translate('airLeadInfoPopupNotes')}}:</span>
                    <div>{{settings.notes}}</div>
                </div>
                <div class="airLead__info" v-if="settings.location">
                    <span>{{translate('airLeadInfoPopupLocation')}}:</span>
                    <div>
                       <a @click="viewOnMapAction()" >{{translate('airLeadInfoPopupViewOnMap')}}</a>
                    </div>
                </div>
            </div>
            <audio controls='controls' v-if="settings.audio" class="airlead-audio">
                <source :src="settings.audio.audio_url">
            </audio>
            <div v-if="settings.images.length > 0" class="airLeadImages">
                <div class="airLeadImage" v-for="item in settings.images" :key="item.id">
                    <img @click="onImageClick(item)" :src="item.previewUrl" alt="">
                </div>
            </div>
            <template v-slot:modal-footer>
                 <b-button v-if="!settings.hideOkButton" class="btn-primary" variant="primary" @click="onClose">
                    <template v-if="settings.okButtonText">{{ settings.okButtonText }}</template>
                    <template v-else>{{translate('OK')}}</template>
                </b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import _ from "lodash";

export default {
    data() {
        return {
            airLeadInfoPopup: _.isEmpty(this.settings)
        }
    },
     props: {
        settings: {
                type: [Object, null],
                default: () => {
                    return {}
                }
            },
        },
    watch: {
        settings(newValue) {
            this.airLeadInfoPopup = !_.isEmpty(newValue)
        }
    },
    methods: {
        async onClose() {
            this.settings.show = false
            if (this.settings.onCancelHandler) {
                try {
                    await this.settings.onCancelHandler(this.settings)
                } catch (error) {
                    this.showErrorModal(error.message)
                }
            }
        },
        onImageClick(item) {
            window.open(item.originUrl, '_blank')
        },
        getServiceName(type) {
            switch (type) {
                case 'sink': {
                    return this.translate('airLeadSink') 
                }
                case 'call': {
                    return this.translate('airLeadCallThem')  
                }
                case 'more_service': {
                    return this.translate('airLeadMoreService')
                }
                case 'units': {
                    return this.translate('airLeadMoreUnits')
                }
                default: {
                    return ''
                }
            }
        },
        viewOnMapAction() {
            let url = `https://www.google.com/maps/place/` + this.settings.location.lat + ',' + this.settings.location.lng + `/@` + this.settings.location.lat + `,` + this.settings.location.lng + `,17z`
            window.open(url, '_blank')
        }
    }
}
</script>

<style>
    .airLead {
        display: flex;
        flex-direction: column;
        align-items: center;
    }
    .airLead__title {
        margin-bottom: 20px;
    }
    .airLead__info {
        display: flex;
        width: 70%;
        margin-bottom: 15px;
    }
    .airLead__info div {
        width: 100%;
        text-align: start;
        flex: 3 0;
    }
    .airLead__info span {
        width: 100%;
        text-align: start;
        flex: 2 0;
    }
    .airLead__info a {
        color: rgb(50, 110, 234) !important;
        text-decoration: underline !important;
        cursor: pointer;
    }
    .airLeadImages {
        margin-top: 16px;
        width: 70%;
        display: inline-flex;
        flex-direction: row;
    }
    .airLeadImage img {
        width: 70px;
        cursor: pointer;
        margin-left: 4px;
    }
    .airlead-audio {
        height: 40px !important;
        width: 70% !important;
    }
</style>